import { getQuery } from "@/utils/query";
import { getLocalIdentity } from "@meitu/xdesign-identity";

export const MODULE_ID = "hbsj";

export const SCENE = "aippt";

export const CLIENT_ID = "1189857523";

export const getClientID = () => {
  const query = getQuery();
  return query?.clientId || CLIENT_ID;
};

export const getAppKey = (oid?: number) => {
  const identity = getLocalIdentity();

  if (oid ?? identity?.oid) {
    return process.env.NEXT_PUBLIC_ENV === "release"
      ? "3EDDE044EAA4A219"
      : "DEFFFDF497E5BA5A";
  }

  return process.env.NEXT_PUBLIC_ENV === "release"
    ? "C5F34252F04B6D50"
    : "2CC0D80138565B20";
};

// 1 为(预发布+正式),0 或者不传 为正式模式
export const PREVIEW_MODE = process.env.NEXT_PUBLIC_ENV === "release" ? 0 : 1;

export const MATRIX_CHANNEL = "mtsjs_web";

export const getPreFix = () => {
  let preFix = process.env.NEXT_PUBLIC_ENV;
  if (preFix === "release") {
    preFix = "";
  }
  return preFix;
};

export const getPPTUrl = () => {
  return `https://${getPreFix()}ppt.designkit.com`;
};

export const getApiHostForWeb = () => {
  return `https://${getPreFix()}webapi.designkit.com`;
};

// api内网域名
export const getIntranetHost = () => {
  // 开发环境继续走公网
  if (process.env.NODE_ENV === "development" || typeof window !== "undefined") {
    return getApiHostForWeb();
  }
  return `http://${getPreFix()}webapi-pc.m.com`;
};

export const getWsHostname = () => {
  let preFix = process.env.NEXT_PUBLIC_ENV;
  return preFix === "pre"
    ? "wss://prewebsocket-design.meitu.com"
    : preFix === "beta"
    ? "wss://betawebsocket-design.meitu.com"
    : "wss://websocket-design.meitu.com";
};

export const getDesignHome = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3003";
  }
  let preFix = process.env.NEXT_PUBLIC_ENV;
  if (preFix === "release") {
    preFix = "www";
  }
  return `https://${preFix}.designkit.com`;
};

export const TITLE = "美图设计室LivePPT";

export const WORKBENCH_DESCRIPTION =
  "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";

export const WORKBENCH_KEYWORDS =
  "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";

export const HOME_DESCRIPTION =
  "美图设计室AI PPT是一款AI智能化生成演示内容的在线工具,只需输入一句话,即可实现AI生成高质量PPT.借助强大的 AI 技术,轻松实现ai生成ppt、ai合成ppt、ai制作ppt、一键生成ppt,美图ai ppt工具让你轻松打造精美的PPT,支持一键智能排版/配色,以及丰富的模板和素材库。";

export const HOME_KEYWORDS =
  "ai 生成 ppt,ai 合成 ppt,ai 制作 ppt,一键生成 ppt 的 ai,美图 ai ppt";
